<div class="submit-lead">
	<div class="header">
		<img src="/luhambo-leads-management/assets/cashloan.jpeg" />
	</div>

	<div class="body" [ngClass]="{'flip': success, 'back': success}">
		<div *ngIf="!success">
			<pw-input [data]="{name: 'name', label: 'Name:', type: 'text'}" [parentFormGroup]="budgetInsuranceForm" [formStatus]="formStatus"></pw-input>

			<pw-input [data]="{name: 'surname', label: 'Surname:', type: 'text'}" [parentFormGroup]="budgetInsuranceForm" [formStatus]="formStatus"></pw-input>

			<pw-input [data]="{name: 'telephone', label: 'Cellphone:', type: 'number'}" [parentFormGroup]="budgetInsuranceForm" [formStatus]="formStatus"></pw-input>
			
			<pw-input [data]="{name: 'id', label: 'ID Number:', type: 'number'}" [parentFormGroup]="budgetInsuranceForm" [formStatus]="formStatus"></pw-input>
			
			<pw-input [data]="{name: 'email', label: 'Email:', type: 'email'}" [parentFormGroup]="budgetInsuranceForm" [formStatus]="formStatus"></pw-input>
			
			<pw-dropdown [data]="agentData" [parentFormGroup]="budgetInsuranceForm"></pw-dropdown>

			<div [formGroup]="budgetInsuranceForm">
				<label class="date-picker-label">Date of Birth</label>
				<input type="date" class="date-picker" [formControlName]="'dob'" />
			</div>

			<pw-button [data]="{name: 'submit', label: 'Submit', disabled: false}" (click)="submitLead()"></pw-button>
		</div>

		<div class="back message" *ngIf="success">
			<div class="message__heading">
				Lead Submitted
			</div>

			<div class="message__message">
				Your details have been successfully submitted. An assistant will contact you shortly. To help speed up
				the process, have your ID ready.
			</div>
		</div>
	</div>

	<div class="reset" *ngIf="success" >
		<pw-button [data]="{name: 'ok', label: 'Ok', disabled: false}" (click)="resetForm()"></pw-button>
	</div>

	<div class="footer">
		Cashloan. All rights reserved. 
	</div>
</div>